import { ActionType, ProColumns } from "@ant-design/pro-components";
import { Badge, Form, Input } from "antd";
import BoxContainer from "base/ui/components/BoxContainer";
import CustomButton from "base/ui/components/Button";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
// icons
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import CustomSelect from "base/ui/components/CustomSelect";
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import * as Icon from "base/ui/components/Icons";
import CustomDatePicker from "base/ui/components/Input/customDatePicker";
import dayjs from 'dayjs';
import usePartialState from 'hooks/usePartialState';
import { cloneDeep } from 'lodash';
import PageWrapper from "pages/Components/PageWrapper";
import { SearchBox, SearchForm, SearchItem } from "pages/Components/SearchBox";
import { SearchModel } from 'pages/model';
import { useTranslation } from "react-i18next";
import { CommonModel } from 'services/Main/common_services';
import { DataTypeReportZNS } from 'services/ZNS/zns_services';
import * as rootStore from 'stores/root_store';
import { znsPresenter, znsStore } from 'stores/root_store';
import { DATE_FORMAT_POST, DATE_TIME_FORMAT_DEFAULT, MVC_URL, PAGE_SIZE_DEFAULT, SYSTEM_TITLE, VARIABLE_CHECK_ZALO } from "utils/constants";
import { getPlantCode } from 'utils/localStorageHelper';


// trạng thái gửi tin
const statusMessage = [
  {
    value: true,
    label: "Thành công",
  },
  {
    value: false,
    label: "Không thành công",
  },
];

// trạng thái phản hồi
const statusResponse = [
  {
    value: true,
    label: "Có",
  },
  {
    value: false,
    label: "Không",
  },
];


// BÁO CÁO KẾT QUẢ GỬI ZNS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const createReportZNS = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t("page-title.report-zns") + " - " + SYSTEM_TITLE;

    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();


    const [reportTable, setReportTable] = useState<DataTypeReportZNS[]>([]);

    const tableRef = useRef<ActionType>();


    const [dataSearch, setDataSearch] = useState<SearchModel>({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        orderBy: '',
        orderByDesc: '',
      },
      env: VARIABLE_CHECK_ZALO
      // status: true,
    });

    const [loading, setLoading] = usePartialState({ dataSource: false, buttonSearch: false, export: false });
    // data loại nghiệp vụ
    const [dropdownNghiepVuTemplate, setDropdownNghiepVuTemplate] = useState<CommonModel[]>([]);
    const [dropdownZnsTemplate, setDropdownZnsTemplate] = useState<CommonModel[]>([]);


    const [znsName, setZnsName] = useState('')
    // ============================================================================================
    const showDrawer = () => {
      setOpen(true);
    };

    const onCloseDrawer = () => {
      setOpen(false);
    };


    const columns: ProColumns<DataTypeReportZNS>[] = [
      {
        title: t("zalo-notification.stt"),
        dataIndex: "stt",
        key: "stt",
        align: "center",
        width: 60,
        ellipsis: true,
      },
      // id mẫu zns
      {
        title: t("zalo-notification.zns-id"),
        dataIndex: "znsId",
        key: "znsId",
        align: "center",
        width: 120, ellipsis: true,
      },
      // tên mẫu zns
      {
        title: t("zalo-notification.zns-name"),
        dataIndex: "znsTemplateName",
        key: "znsTemplateName",
        ellipsis: true,
        width: 300,
      },
      // loại nghiệp vụ
      {
        title: t("zalo-notification.major-type"),
        dataIndex: "workFlowName",
        key: "workFlowName",
        ellipsis: true,
        width: 200
      },
      // tracking id
      {
        title: t("zalo-notification.tracking-id"),
        dataIndex: "taskCode",
        key: "taskCode",
        align: "center",
        width: 150,
        render: (_, record) => {
          return (
            <a target='_blank' href={MVC_URL + `/Work/Task/Edit/${record.taskId}`} rel="noreferrer">{_}</a>
          )
        }
      },
      // sđt gửi
      {
        title: t("zalo-notification.sdt-send"),
        dataIndex: "phone",
        key: "phone",
        ellipsis: true,
        width: 120
      },
      // Mã khách hàng
      {
        title: t('customer.appointment.customer-code'),
        dataIndex: 'profileCode',
        key: 'profileCode',
        className: '!whitespace-nowrap !min-w-[150px]',
        width: 120,
        ellipsis: true,
      },
      // Tên khách hàng
      {
        title: t('search-form.customer-name'),
        dataIndex: 'profileName',
        key: 'profileName',
        className: '!whitespace-nowrap !min-w-[150px]',
        width: 300,
        ellipsis: true,
      },
      // Tên liên hệ
      {
        title: t('zalo-notification.contact'),
        dataIndex: 'contactName',
        key: 'contactName',
        className: '!whitespace-nowrap !min-w-[150px]',
        width: 300,
        ellipsis: true,
      },
      // trạng thái gửi tin
      {
        title: t("search-form.send-status"),
        dataIndex: "isSend",
        key: "isSend",
        width: 150,
        render: (_, record) => (
          <Badge
            status={record.isSend ? 'success' : 'error'}
            text={
              <span
                className={`${record.isSend ? '!text-textSuccess' : '!text-textError'
                  } !whitespace-nowrap`}
              >
                {record.isSend ? 'Thành công' : record.isSend === null ? '' : 'Thất bại'}
              </span>
            }
          />
        ),
      },
      // Message
      {
        title: 'Message',
        dataIndex: 'mess',
        key: 'mess',
        className: '!whitespace-nowrap !min-w-[150px]',
        width: 300,
        ellipsis: true,
      },
      // Thời gian gửi tin
      {
        title: t('zalo-notification.send-time'),
        dataIndex: 'sendingTime',
        key: 'sendingTime',
        align: 'center',
        valueType: 'dateTime',
        fieldProps: {
          format: DATE_TIME_FORMAT_DEFAULT,
        },
        ellipsis: true,
        className: '!whitespace-nowrap',
        width: 150,
      },
      // Trạng thái phản hồi
      {
        title: t('search-form.feedback-status'),
        dataIndex: 'statusResponse',
        key: 'statusResponse',
        className: '!min-w-[130px]',
        width: 130,
        render: (_, record) => (
          <div className="!w-full !flex !items-center">
            {record.statusResponse === 'Có' ? (
              <CheckCircleOutlined className="text-textSuccess custom__icon--antd" />
            ) : (
              <CloseCircleOutlined className="text-textError custom__icon--antd" />
            )}
            <span className={`${record.statusResponse === 'Có' ? '!text-textSuccess' : '!text-textError'} ml-2`}>
              {record.statusResponse}
            </span>
          </div>
        ),
      },
      // Thời gian phản hồi
      {
        title: t('zalo-notification.feedback-time'),
        dataIndex: 'createTime',
        key: 'createTime',
        align: 'center',
        valueType: 'dateTime',
        fieldProps: {
          format: DATE_TIME_FORMAT_DEFAULT,
        },
        ellipsis: true,
        className: '!whitespace-nowrap',
        width: 150,
      },
      // điểm
      // {
      //   title: t("zalo-notification.score"),
      //   dataIndex: "point",
      //   key: "point",
      //   onCell: () => ({ style: { textAlign: "right" } }),
      // },
    ];

    // Lấy ngày bằng common data
    const getDateByKey = async () => {
      await rootStore.commonPresenter.getDateByCommonDate(rootStore.commonStore, 'ThisMonth');
      if (rootStore.commonStore.commonDate.fromDate) {
        form.setFieldValue("fromTime", dayjs(rootStore.commonStore.commonDate.fromDate))
        form.setFieldValue("toTime", dayjs(rootStore.commonStore.commonDate.toDate))
        setDataSearch(Object.assign(dataSearch, {
          fromTime: rootStore.commonStore.commonDate.fromDate,
          toTime: rootStore.commonStore.commonDate.toDate,
        }))
      } else {
        form.setFieldValue("fromTime", undefined)
        form.setFieldValue("toTime", undefined)
      }
      tableRef.current?.reload();
    };


    useEffect(() => {
      Promise.all([
        getDateByKey(),
        getDropdownNghiepVuTemplate(),
        getDropdownZnsTemplate(),

      ]);
    }, []);

    // HANDLE CLICK BUTTON SEARCH
    const handleSearch = async (values: DataTypeReportZNS | any) => {
      setLoading({ buttonSearch: true });

      const dataResult = cloneDeep(values);
      Object.assign(dataResult, {
        fromTime: dataResult.fromTime ? dayjs(dataResult.fromTime).format(DATE_FORMAT_POST) : undefined,
        toTime: dataResult.toTime ? dayjs(dataResult.toTime).format(DATE_FORMAT_POST) : undefined,
      });

      setDataSearch({
        // loại bỏ những field không có giá trị
        ...Object.fromEntries(Object.entries(dataResult).filter(([_, value]) => !!value)),
        status: dataResult.status ? true : dataResult.status === undefined ? undefined : false,
        statusResponse: dataResult.statusResponse ? true : dataResult.statusResponse === undefined ? undefined : false,
        paging: {
          pageSize: PAGE_SIZE_DEFAULT,
          pageIndex: 1,
        },
        env: VARIABLE_CHECK_ZALO
      });
      onCloseDrawer();
      setLoading({ buttonSearch: false });
    };

    // Handle get list data product
    const getReportZNS = async (dataSearch: object) => {
      await znsPresenter.reportSendZNS(znsStore, dataSearch);
      if (znsStore.znsReportRespone.isSuccess) {
        setReportTable(znsStore.znsReportRespone.data);
        return znsStore.znsReportRespone.data;
      }
      return [];
    };

    // Call api dropdown loại nghiệp vụ
    const getDropdownNghiepVuTemplate = async () => {
      await znsPresenter.listDropdownNghiepVuTemplate(znsStore);
      if (znsStore.dropdownNghiepVuTemplateRespone.isSuccess) {
        setDropdownNghiepVuTemplate(znsStore.dropdownNghiepVuTemplateRespone.data);
      }
    };
    // Call api dropdown mẫu ZNS
    const getDropdownZnsTemplate = async () => {
      await znsPresenter.listDropdownZNSTemplate(znsStore);
      if (znsStore.dropdownZnsTemplateRespone.isSuccess) {
        setDropdownZnsTemplate(znsStore.dropdownZnsTemplateRespone.data);
      }
    };

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t("page-title.report-zns"),
          },
        ]}
        extras={
          <>
            <CustomButton icon={<Icon.Download className="!fill-black" />}
              onClick={async () => {
                setLoading({ export: true });

                const dataResult = cloneDeep(dataSearch);
                const { paging, ...search } = dataResult;

                await znsPresenter.exportReportZNS(Object.assign(Object.assign(search,
                  {
                    companyCode: getPlantCode(),
                    lang: rootStore.uiStore.language,
                    env: VARIABLE_CHECK_ZALO,
                    znsName: znsName ? znsName : undefined
                  }
                )));

                setTimeout(() => {
                  setLoading({ export: false });

                }, 1000);
              }}

              loading={loading.export}
              disabled={loading.export}
            >
              {t("btn.export")}
            </CustomButton>
            <CustomButton
              onClick={showDrawer}
              type="primary"
              color="#EFF4F9"
              className="!px-0 w-8"
            >

              <Icon.Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Form search */}
        <BoxContainer fullHeight>
          <CustomProTable<DataTypeReportZNS>
            key={"stt"}
            size="small"
            bordered
            className="[&_.ant-table-wrapper_.ant-table.ant-table-bordered_>.ant-table-container]:rounded-none"
            dataSource={reportTable}
            actionRef={tableRef}
            columns={columns}
            options={{ reload: true, density: false, search: false, setting: false, fullScreen: true }}
            dateFormatter="string"
            request={async (params = {}, sort, filter) => {
              const data = await getReportZNS({
                ...dataSearch,
                companyCode: getPlantCode(),
                env: VARIABLE_CHECK_ZALO,
                paging: {
                  ...dataSearch.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                },
              });

              if (Object.values(sort).length) {
                setDataSearch({
                  ...dataSearch,
                  companyCode: getPlantCode(),
                  env: VARIABLE_CHECK_ZALO,
                  paging: {
                    ...dataSearch.paging,
                    orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  },
                });
              }

              return {
                data: data,
                success: znsStore.znsReportRespone.isSuccess,
              };
            }}
            pagination={{
              ...tablePagination(dataSearch, setDataSearch),
              total: znsStore.znsReportRespone.paging?.totalCount,
            }}
            search={false}
            scroll={{ x: 2100, y: 500 }}
          />
        </BoxContainer>

        <SearchBox
          onClose={onCloseDrawer}
          open={open}
          className="lg:!w-[50%]"
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              onClick={() => {
                form.submit();
              }}
              disabled={loading.buttonSearch}
              loading={loading.buttonSearch}
            >
              {t("btn.search")}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={(values) => {
              handleSearch(values);
              tableRef.current?.reload();
            }}
            initialValues={{
              // status: true,
              // statusResponse: true
            }}
          >
            {/* mẫu ZNS */}
            <SearchItem label={t("search-form.zns-code")} name={"znsId"}>
              <CustomSelect
                options={dropdownZnsTemplate}
                fieldNames={{ label: 'value', value: 'key' }}
                showSearch
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(value, option) => {
                  if (!Array.isArray(option))
                    setZnsName(option.value);
                }}
                allowClear
              />
            </SearchItem>
            {/* trạng thái gửi tin */}
            <SearchItem
              label={t("search-form.send-status")}
              name={"status"}
            >
              <CustomSelect
                allowClear
                options={statusMessage} />
            </SearchItem>
            {/* trạng thái phản hồi */}
            <SearchItem
              label={t("search-form.feedback-status")}
              name={"statusResponse"}
            >
              <CustomSelect allowClear options={statusResponse} />
            </SearchItem>
            {/* loại nghiệp vụ */}
            <SearchItem
              label={t("search-form.type-major")}
              name={"workflow"}
            >
              <CustomSelect
                options={dropdownNghiepVuTemplate}
                fieldNames={{ label: 'value', value: 'key' }}
                showSearch
                allowClear
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>
            {/* ngày gửi từ */}
            <SearchItem
              label={`${t("search-form.send-date")} ${t("search-form.from")}`}
              name={"fromTime"}
            >
              <CustomDatePicker allowClear />
            </SearchItem>
            {/* ngày gửi đến */}
            <SearchItem
              label={`${t("search-form.send-date")} ${t("search-form.to")}`}
              name={"toTime"}
            >
              <CustomDatePicker allowClear />
            </SearchItem>
            {/* Mã tracking */}
            <SearchItem label={t('search-form.tracking-code')} name='taskCode'>
              <Input />
            </SearchItem>
            {/* Số điện thoại sđt gửi tin */}
            <SearchItem label={t('search-form.sdt-send')} name='phone'>
              <Input />
            </SearchItem>
            {/* Mã khách hàng */}
            <SearchItem label={t('segment.ma-kh')} name='profileCode'>
              <Input />
            </SearchItem>
            {/* Tên khách hàng */}
            <SearchItem label={t('search-form.customer-name')} name='profileName'>
              <Input />
            </SearchItem>
            {/* Thời gian gửi tin */}
            {/* <SearchItem
              label={`Thời gian gửi tin`}
              name={"time"}
            >
              <TimePicker
                className='!w-full'
              />
            </SearchItem> */}
            {/* Slider chấm điểm */}
            {/* <SearchItem
              label={`${t("search-form.mark")}`}
              name={"sliderNumber"}
            >
              <Slider min={0} max={100} range onChange={onChangeNumber} />
            </SearchItem> */}
            {/* Chấm điểm từ và đến */}
            {/* <SearchItem label={`${t("search-form.mark")}`}>
              <Space.Compact block rootClassName="items-center">
                <Form.Item name={"fromPoint"} className="!m-0 w-1/2">
                  <InputNumber
                    min={0}
                    className="!w-full !border-r-transparent hover:!border-r-primary focus:!border-r-primary"
                    max={100}
                  />
                </Form.Item>
                <Input
                  placeholder="~"
                  className="!w-[30px] !border-x-0 hover:border-x-0 focus:border-x-0 pointer-events-none disabled:!bg-white"
                  disabled
                />
                <Form.Item name={"toPoint"} className="!m-0 w-1/2">
                  <InputNumber
                    min={0}
                    className="!w-full !border-l-transparent hover:!border-l-primary focus:!border-l-primary"
                    max={100}
                  />
                </Form.Item>
              </Space.Compact>
            </SearchItem> */}
            {/* <div className={`col-span-2`}>
              <Row gutter={12}>
                <Col span={12}>
                  <Form.Item name={'fromPoint'} className="m-0">
                    <InputNumber min={0} className="w-full mt-4" max={100} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name={'toPoint'} className="m-0">
                    <InputNumber min={0} className="w-full mt-4" max={100} />
                  </Form.Item>
                </Col>
              </Row>
            </div> */}
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createReportZNS;
